export interface NoPaymentMethodsResult {
  resultPageType?: string | null;
}

export const NO_PAYMENT_METHODS_RESULT_TYPE = 'no_payment_methods';

export const isNoPaymentMethodsResult = (
  resultOfPay: NoPaymentMethodsResult | null | undefined,
): boolean => resultOfPay?.resultPageType === NO_PAYMENT_METHODS_RESULT_TYPE;
